/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Fund_LabelInputs */

const en_support_fund_label = /** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Sovereign Fund`)
};

const es_support_fund_label = /** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo Soberano de la Plataforma`)
};

const fr_support_fund_label = /** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonds Souverain de la Plateforme`)
};

const de_support_fund_label = /** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform Sovereign Fonds`)
};

const id_support_fund_label = /** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dana Sovereign Platform`)
};

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const ja_support_fund_label = en_support_fund_label;

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const zh_support_fund_label = en_support_fund_label;

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const ar_support_fund_label = en_support_fund_label;

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const it_support_fund_label = en_support_fund_label;

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const ru_support_fund_label = en_support_fund_label;

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const pt_support_fund_label = en_support_fund_label;

/** @type {(inputs: Support_Fund_LabelInputs) => LocalizedString} */
const ko_support_fund_label = en_support_fund_label;

/**
* | output |
* | --- |
* | "Platform Sovereign Fund" |
*
* @param {Support_Fund_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_fund_label = /** @type {((inputs?: Support_Fund_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Fund_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_fund_label(inputs)
	if (locale === "es") return es_support_fund_label(inputs)
	if (locale === "fr") return fr_support_fund_label(inputs)
	if (locale === "de") return de_support_fund_label(inputs)
	if (locale === "ja") return ja_support_fund_label(inputs)
	if (locale === "zh") return zh_support_fund_label(inputs)
	if (locale === "ar") return ar_support_fund_label(inputs)
	if (locale === "id") return id_support_fund_label(inputs)
	if (locale === "it") return it_support_fund_label(inputs)
	if (locale === "ru") return ru_support_fund_label(inputs)
	if (locale === "pt") return pt_support_fund_label(inputs)
	return ko_support_fund_label(inputs)
});